import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import RandomModelsSection from './components/RandomModelsSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CatalogPage from './pages/CatalogPage';
import ContactPage from './pages/ContactPage';
import ModelPreviewModal from './components/ModelPreviewModal';
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import { isAuthenticated, trackVisit } from './services/adminStorage';

function App() {
  const [activeTab, setActiveTab] = useState(() => {
    if (typeof window !== 'undefined' && (window.location.pathname.includes('/admin') || window.location.hash.includes('admin'))) {
      return 'admin';
    }
    return 'home';
  });

  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(() => isAuthenticated());
  const [selectedModel, setSelectedModel] = useState(null);

  useEffect(() => {
    trackVisit();

    const handleHashOrUrl = () => {
      if (window.location.pathname.includes('/admin') || window.location.hash.includes('admin')) {
        setActiveTab('admin');
      }
    };

    window.addEventListener('popstate', handleHashOrUrl);
    window.addEventListener('hashchange', handleHashOrUrl);
    return () => {
      window.removeEventListener('popstate', handleHashOrUrl);
      window.removeEventListener('hashchange', handleHashOrUrl);
    };
  }, []);

  const handleNavigate = (tab) => {
    setActiveTab(tab);
    if (tab === 'admin') {
      window.location.hash = 'admin';
      setIsAdminLoggedIn(isAuthenticated());
    } else if (window.location.hash.includes('admin')) {
      window.location.hash = '';
    }
  };

  const handleOpenModelModal = (model) => {
    setSelectedModel(model);
  };

  const handleCloseModelModal = () => {
    setSelectedModel(null);
  };

  const handleChoosePlan = (plan) => {
    const text = encodeURIComponent(`Olá, Suzume Technologies! Tenho interesse em contratar a ${plan.name} (${plan.price}). Como podemos prosseguir?`);
    window.open(`https://wa.me/5511932654166?text=${text}`, '_blank');
  };

  // Se a aba ativa for Admin
  if (activeTab === 'admin') {
    if (isAdminLoggedIn) {
      return (
        <AdminLayout 
          onLogout={() => setIsAdminLoggedIn(false)}
          onBackToStore={() => handleNavigate('home')}
        />
      );
    }
    return (
      <AdminLogin 
        onLoginSuccess={() => setIsAdminLoggedIn(true)}
        onBackToStore={() => handleNavigate('home')}
      />
    );
  }

  return (
    <div className="app-container">
      {/* Header Corporativo */}
      <Navbar 
        activeTab={activeTab} 
        onNavigate={handleNavigate} 
      />

      {/* Conteúdo Dinâmico por Aba */}
      <main>
        {activeTab === 'home' && (
          <>
            <HeroSection 
              onExploreCatalog={() => handleNavigate('catalog')}
              onContact={() => handleNavigate('contact')}
            />
            <RandomModelsSection 
              onSelectModel={handleOpenModelModal}
              onGoToCatalog={() => handleNavigate('catalog')}
            />
            <PricingSection 
              onChoosePlan={handleChoosePlan}
              onContact={() => handleNavigate('contact')}
            />
            <TestimonialsSection />
            <FaqSection />
          </>
        )}

        {activeTab === 'catalog' && (
          <CatalogPage 
            onSelectModel={handleOpenModelModal} 
          />
        )}

        {activeTab === 'contact' && (
          <ContactPage />
        )}
      </main>

      {/* Modal de Pré-visualização de Modelo */}
      {selectedModel && (
        <ModelPreviewModal 
          model={selectedModel} 
          onClose={handleCloseModelModal} 
        />
      )}

      {/* Rodapé Corporativo */}
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
